let memoGUID: string;

export function storeGUID(GUID: string) {
    memoGUID = GUID;
}

export function getGUID(): string {
    return memoGUID;
}
